var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.076,
    height: 66.66,
    viewBox: "0 0 52.076 66.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_613",
    transform: "translate(7.5 7.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.5, -7.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "np_pin_3134300_000000-2",
    d: "M34.448,2.5C24.21,2.5,15.91,10.385,15.91,20.114a16.927,16.927,0,0,0,3.518,10.332,3.653,3.653,0,0,0,.376,1.088L30.809,52.042a4.185,4.185,0,0,0,7.278,0L49.093,31.5a3.653,3.653,0,0,0,.376-1.088,16.927,16.927,0,0,0,3.518-10.332c0-9.691-8.3-17.576-18.538-17.576Z",
    transform: "translate(-8.41 5)",
    fill: "#ffaf2f"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_322",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(10 10)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.757b538d3b8d8e7cff653137b3dfa004.svg";
export { ForwardRef as ReactComponent };